import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CFormGroup,
  CInput,
  CInputCheckbox,
  CInvalidFeedback,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { apiCallSP, apiCallSPGet, apiCallSPPost } from "src/_apiConfig/apiCall";
import ToastMessage from "src/_components/ToastMessage";
import {
  addToastError,
  addToastSuccess,
  AlertResponse,
} from "src/_constants/alert.type";
import Auth from "src/auth";

const RoleEdit = () => {
  const { authenticated } = Auth();
  //  const history = useHistory();
  let { id } = useParams();
  const [loading, setloading] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [isActive, setIsActive] = useState(false);

  const [submitted, setSubmitted] = useState(false);
  const [toasts, setToasts] = useState(AlertResponse);
  //const [loading, setloading] = useState(false); // page loading
  const [validated, setValidated] = useState(false);
  const [menuListData, setMenuListData] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const history = useHistory();
  const [isRightCheck, setIsRightCheck] = useState(false);
  useEffect(() => {
    getRoleDetails(id);
    getRightsList(id);
    // console.log(authenticated.role);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);
  // const getUserList = async () => {
  //   setloading(true);
  //   //
  //   // const header = new Headers();
  //   // const response = await apiCall(
  //   //   `User/GetById?id=${userid}`,
  //   //   "GET",
  //   //   header,
  //   //   null
  //   // );

  //   // const jsonobj = await response.json();

  //   setloading(false);
  // };
  const getRoleDetails = async (id) => {
    if (authenticated) {
      setloading(true);
      await apiCallSPGet(`RoleMaster/SelectById?roleMasterId=${id}`).then(
        (res) => {
          if (res.success) {
            console.log("getRoleDetails", res.data);
            setRoleName(res.data.roleName);
            setIsActive(res.data.isActive);
          }
          setloading(false);
        }
      );
    }
  };
  const getRightsList = async (id) => {
    if (authenticated) {
      setloading(true);
      await apiCallSPGet(`RoleRights/ListById?roleid=${id}`).then((res) => {
        if (res.success) {
          setMenuListData(res.data);
          setMenuData(res.data);
        }
        setloading(false);
      });
    }
  };

  const handleRoleDetails = (e, index) => {
    index = index - 1;
    menuData[index].isMapped = e.target.checked;
    setMenuData([...menuData]);

    (menuData[index].parentId === 0 || menuData[index].parentId > 0) &&
      menuData
        .filter(
          (x) => menuData[index].rightsId === x.parentId && x.parentId > 0
        )
        // eslint-disable-next-line array-callback-return
        .map((res) => {
          menuData[res.srNo - 1].isMapped = e.target.checked;
          setMenuData([...menuData]);

          // handleRoleDetailsAction(e.target.checked, res.ModuleId);
        });

    const rightCheckList = [];
    // eslint-disable-next-line array-callback-return
    menuData.map((data) => {
      if (data.isMapped === true) {
        rightCheckList.push(data.rightsId);
      }
    });

    setIsRightCheck(rightCheckList.length === 0);
  };

  const CheckBox = (res, index, checkBoxPreFix) => {
    return (
      <>
        <CFormGroup variant="custom-checkbox" inline>
          <CInputCheckbox
            custom
            id={`${checkBoxPreFix}${res.srNo}`}
            name={`${checkBoxPreFix}${res.srNo}`}
            value={res.rightsId}
            onChange={(e) => handleRoleDetails(e, res.srNo)}
            checked={res.isMapped === true ? "checked" : ""}
            disabled={
              res.parentId === 0
                ? false
                : !menuListData.find(
                    (item) => item.rightsId === res.parentId && item.isMapped
                  )
            }
          />
          <CLabel
            variant="custom-checkbox"
            htmlFor={`${checkBoxPreFix}${res.srNo}`}
          >
            {res.title}
          </CLabel>
        </CFormGroup>
        {/* <div className="checkbox-wrapper">
          <label>
            <input
              key={index}
              type="checkbox"
              value={res.rightsId}
              onChange={(e) => handleRoleDetails(e, res.srNo)}
              checked={res.isMapped === true ? "checked" : ""}
              disabled={
                res.parentId === 0
                  ? false
                  : !menuListData.find(
                      (item) => item.rightsId === res.parentId && item.isMapped
                    )
              }
            />
            <span>{res.title}</span>
          </label>
        </div> */}
      </>
    );
  };
  const SubMenuDataTable = (moduleId, columnClassName = "") => {
    //console.log(moduleId)
    const getSubMenuListItem = menuListData.filter(
      (res) => res.parentId === moduleId
    );

    return (
      <div className="row tableWith99Start">
        {getSubMenuListItem.length > 0 ? (
          getSubMenuListItem.map((res, index) => {
            return (
              <div className="col-xl-4 col-md-6">
                {CheckBox(res, index, "subMenu")}
              </div>
            );
          })
        ) : (
          <div className="col-xl-4 col-md-6"> </div>
        )}
      </div>
    );
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setloading(true);
    const form = event.currentTarget;
    const rightCheckList = [];
    // eslint-disable-next-line array-callback-return
    menuData.map((data) => {
      if (data.isMapped === true) {
        rightCheckList.push(data.rightsId);
      }
    });

    if (form.checkValidity() === false) {
      setSubmitted(true);
      setloading(false);
      //event.stopPropagation();
    } else {
      if (rightCheckList.length === 0) {
        addToastError(
          setToasts,
          "You have to Select atleast one Field in Menu "
        );
        setloading(false);
      } else {
        const data = JSON.stringify({
          roleMasterId: id,
          roleName: roleName,
          isActive: !!isActive,
          parentid: 0,
          insertby: authenticated.userId,
          subroleid: 1, //1 means - subrole = 1 = CGMF
        });
        await apiCallSP("RoleMaster/Update", "PUT", {}, data, 0).then(
          async (res) => {
            if (res.success) {
              console.log("handleSubmit : ", res);

              await handleSubmitRigth(event, id, rightCheckList);
              //  history.push("/master/role");
            } else {
              addToastError(setToasts, res.message, 0);
            }

            //setloading(false);
            //});
          }
        );
      }
      //alert("data Submite");

      setValidated(true);
      setloading(false);
    }
  };

  const handleSubmitRigth = async (event, roleId, rightCheckList) => {
    event.preventDefault();

    setloading(true);

    if (rightCheckList.length > 0 && roleId > 0) {
      const submitdata = JSON.stringify({
        roleid: roleId,
        rightsid: rightCheckList.join(","),
        insertby: authenticated.userId,
      });

      await apiCallSPPost("RoleRights/MappingInsert", submitdata).then(
        (res) => {
          if (res.success) {
            addToastSuccess(setToasts, res.message);
            //alert("data added Succefully");
            history.push("/master/role");
          }

          setloading(false);
        }
      );
    } else {
      setloading(false);
    }
  };
  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <CCardHeader>
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Edit Role Right</h3>
          </CCol>
        </CRow>
      </CCardHeader>

      <CForm
        onSubmit={handleSubmit}
        noValidate
        validated={validated}
        className="was-validation"
      >
        <CRow className="mb-3 ml-1 mt-2">
          <CCol xl={4}>
            <CLabel> Role Name : </CLabel>
            <CInput
              required
              type="text"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
              id="validationCustom03"
              invalid={submitted && roleName === ""}
              aria-describedby="validationCustom03Feedback"
            />
            <CInvalidFeedback className="validationCustom03">
              Please enter Role Name
            </CInvalidFeedback>
          </CCol>
          <CCol xl={2}>
            <CFormGroup variant="custom-checkbox" inline>
              <CInputCheckbox
                custom
                name={`isactive`}
                value={isActive}
                id="chkIsViewOnly"
                placeholder=""
                checked={isActive ? true : false}
                onClick={() => {
                  setIsActive(!isActive);
                }}
              />
              <CLabel variant="custom-checkbox" htmlFor={`chkIsViewOnly`}>
                Active
              </CLabel>
            </CFormGroup>
            {/* <CLabel htmlFor="formFile" className="col-form-label">
              IsActive:
            </CLabel>

            <input
              style={{
                margin: 10,
              }}
              id="chkIsViewOnly"
              placeholder=""
              type="checkbox"
              checked={isActive ? true : false}
              onClick={() => {
                setIsActive(!isActive);
              }}
            /> */}
          </CCol>
          <CCol xl={2}></CCol>
        </CRow>
        {isRightCheck === true && (
          <CRow className="mb-3 ml-1 mt-2">
            <CCol
              xl={12}
              style={{
                width: "100%",
                marginTop: "0.25rem",
                fontSize: "80%",
                color: "#e55353",
              }}
            >
              You have to Select atleast one Menu
            </CCol>
          </CRow>
        )}
        <CRow className={"ml-1"}>
          <CCol>
            <table className="table table-striped table-hover ml-1">
              <thead>
                <tr>
                  {/* <th>Sr. No</th> */}
                  <th style={{ width: "20%" }}>Menu</th>
                  <th>Sub Menu</th>
                  {/* <th style={{ width: "5%" }}>Sr. No</th>
                      <th style={{ width: "20%" }}>Menu</th>
                      <th style={{ width: "19%" }}>Sub Menu</th> 
                       <th className="">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {menuListData.length > 0 &&
                  menuListData.map((res, index) => {
                    if (res.parentId === 0) {
                      return (
                        <tr>
                          <td>{CheckBox(res, index, "menu")}</td>
                          <td colSpan={2}>{SubMenuDataTable(res.rightsId)}</td>
                        </tr>
                      );
                    } else {
                      return null;
                    }
                  })}
              </tbody>
            </table>
          </CCol>
        </CRow>
        <CRow className="mb-2 ml-4 mt-2">
          {loading ? (
            <CSpinner className="spinner-grow" color="success" variant="grow" />
          ) : (
            <>
              <CButton type="submit" color="success">
                Update
              </CButton>
              {/* <CButton
                type="button"
                color="success"
                onClick={handleSubmitRigth}
              >
                Add 2
              </CButton> */}

              <CButton color="danger" className="ml-2" to="/master/role">
                Cancel
              </CButton>
            </>
          )}
        </CRow>
      </CForm>
    </>
  );
};

export default RoleEdit;
